import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/acces-rapide.css";

const AccesRapide = () => {
  const navigate = useNavigate();

  const items = [
  {
    label: "Responsabilité Civile Décennale",
    slug: "rcd",
  },
  {
    label: "Dommages Ouvrages",
    slug: "do",
  },
  {
    label: "RC professionnelle",
    slug: "rcp",
  },
  {
    label: "Multirisques professionnelle",
    slug: "mp",
  },
  {
    label: "Auto temporaire",
    slug: "auto-temporaire",
  },
  {
    label: "Auto traditionnelle",
    slug: "auto-traditionnelle",
  },
  {
    label: "VTC / Taxi",
    slug: "vtc-taxi",
  },
  {
    label: "Mutuelle Santé",
    slug: "mutuelle-sante",
  },
];


  return (
    <div className="acces-rapide">
      <h2 className="acces-rapide__title">Accès Rapide à votre Assurance</h2>

      <div className="acces-rapide__grid">
        {items.map((item) => (
          <button
            key={item.label}
            className="acces-rapide__card"
            onClick={() => navigate(`/devis?assurance=${encodeURIComponent(item.label)}`)}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AccesRapide;
